export type BetaValue = {
  betaCubeId: number;
  betaId: number;
  contractMonth: string | null;
  bidValue: number | null;
  askValue: number | null;
  twoWayValue: number;
  isModified: boolean;
  isActive: boolean;
};

export enum BetaValueType {
  Bid = "bidValue",
  Ask = "askValue",
  TwoWay = "twoWayValue",
}
